/* ==========================================================================
   ab2026-23 — «Cómpralo con» del cajón en lista vertical de 2 productos (test A/B)

   Control: el carrusel horizontal de siempre.
   Variante: <html> recibe `ab2026-23-on` ANTES de que el cajón empiece a entrar
   (`on:cart-drawer:before-open`) y el CSS cambia el carrusel por la lista. La
   clase vive en <html>, así que sobrevive al repintado del bloque al añadir.

   La DECISIÓN se toma al abrirse el cajón con el bloque pintado (exposición
   donde divergen), en los dos brazos: el snippet deja aquí un `decisor`
   (GrowthBook) o fija el estado por override/cache. Sin decisor ni estado,
   control. Si el bloque aparece con el cajón ya abierto (se añade la primera
   línea), se decide en ese repintado.

   Eventos propios a GA4 (window.__lejEnviarGa4, de lej-growthbook), con
   ep.variant = control | variante y ep.experiment_id = ab2026-23:
   - `cross_sell_view` al abrirse el cajón con el bloque;
   - `cross_sell_add` al añadir desde el bloque (botón, talla o select nativo);
   - `cross_sell_pdp` al ir a la ficha desde el bloque (en la variante, con
     ep.link = mas_info si es el «+Más info»).

   Cierre del test: borrar este fichero. `grep -ri "ab2026[-_]23"` a cero.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ab2026_23Init) return;
  window.__ab2026_23Init = true;

  var CLAVE = 'ab2026-23';
  var BLOQUE = '.js-cart-drawer .lejrec:not(.lejrec--empty)';
  var estado = null;      /* null = sin decidir · true = variante · false = control */
  var decisor = null;     /* function () -> boolean, lo deja el snippet cuando GB está listo */
  var abierto = false;
  var tratada = false;    /* la apertura en curso ya se expuso */
  var raiz = document.documentElement;

  function guardarCache(v) { try { localStorage.setItem(CLAVE, String(v)); } catch (e) {} }
  function evento(nombre, extra) {
    if (typeof window.__lejEnviarGa4 !== 'function') return;
    var params = { 'ep.experiment_id': CLAVE, 'ep.variant': estado ? 'variante' : 'control' };
    if (extra) for (var k in extra) params[k] = extra[k];
    try { window.__lejEnviarGa4(nombre, params); } catch (e) {}
  }

  function pintar() { raiz.classList.toggle('ab2026-23-on', estado === true); }

  function decidir() {
    if (typeof decisor !== 'function') return;
    var v;
    try { v = decisor() === true; } catch (e) { return; }
    estado = v;
    guardarCache(v);
  }

  function exponer() {
    if (tratada || !document.querySelector(BLOQUE)) return;
    tratada = true;
    decidir();
    pintar();
    evento('cross_sell_view');
  }

  function vigilar() {
    var cajon = document.querySelector('cart-drawer.js-cart-drawer');
    if (!cajon) return false;
    abierto = cajon.hasAttribute('open');
    document.addEventListener('on:cart-drawer:before-open', exponer);
    document.addEventListener('on:cart:after-merge', function () { if (abierto) exponer(); });
    new MutationObserver(function () {
      var ahora = cajon.hasAttribute('open');
      if (ahora && !abierto) exponer();
      if (!ahora) tratada = false;
      abierto = ahora;
    }).observe(cajon, { attributes: true, attributeFilter: ['open'] });
    if (abierto) exponer();
    return true;
  }

  /* Clics del bloque, en los dos brazos. En captura: el handler de lej-cart.js
     llama a preventDefault y repinta el bloque, y aquí basta con saber qué se
     pulsó. */
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t.closest || !t.closest(BLOQUE)) return;
    if (t.closest('.js-lejpc-add, .js-lejmatch-pick')) { evento('cross_sell_add'); return; }
    var enlace = t.closest('a[href]');
    if (enlace) evento('cross_sell_pdp', enlace.classList.contains('js-ab2026-23-info') ? { 'ep.link': 'mas_info' } : null);
  }, true);

  document.addEventListener('change', function (evt) {
    var sel = evt.target;
    if (sel.closest && sel.closest(BLOQUE) && sel.matches('.js-lejpc-nativesize') && sel.value) evento('cross_sell_add');
  }, true);

  var intentos = 0;
  (function arrancar() {
    if (vigilar()) return;
    if (intentos++ < 100) setTimeout(arrancar, 100);
  })();

  window.__ab2026_23 = {
    fijar: function (variante) {
      estado = variante === true;
      pintar();
    },
    decisor: function (fn) { decisor = fn; },
    estado: function () { return estado; }
  };
})();
